import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { ConfiguracionInicialService } from 'src/app/services/configuracioninicial.service';
import { MenuService } from 'src/app/services/menu.service';
import { UtilitariosService } from 'src/app/services/utilitarios.service';
import { ConfiguracionService } from '../../services/configuracion.service';
import { TamanoAppService } from 'src/app/services/tamanoapp.service';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import { AutenticacionService } from '../../services/autenticacion.service';
import { Maestro_Usuarios } from '../../models/generic/Maestro_Usuarios';
import { Maestros_UsuariosService } from '../../services/maestros_usuarios.service';
import { ConfirmacionGenericaComponent } from '../confirmaciongenerica/confirmaciongenerica.component';
import { RespuestaGenerica } from 'src/app/models/generic/RespuestaGenerica';

@Component({
  selector: 'maestros-usuarios',
  templateUrl: './maestros-usuarios.component.html',
  styleUrls: ['./maestros-usuarios.component.scss']
})
export class MaestrosUsuariosComponent implements OnInit{
  
  form: FormGroup;
  mostrarCargando: boolean = false;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  dataSource: MatTableDataSource<Maestro_Usuarios>;
  columnasEncabezado: string[] = ['id', 'login', 'nroDocumento', 'activo', 'nombresApellidos', 'rol', 'acciones'];
  listaDatos: Maestro_Usuarios[] = [];
  consultaSeleccionado: Maestro_Usuarios;
  @ViewChild('appconfirmacion', {static: false}) _appconfirmacion: ConfirmacionGenericaComponent;
  
  constructor(public router: Router,
    public fb: FormBuilder,
    public cd: ChangeDetectorRef,
    public snackbar: MatSnackBar,
    public utilitariosService: UtilitariosService,
    public configuracionInicialService: ConfiguracionInicialService,
    public menuService: MenuService,
    public datosServices: Maestros_UsuariosService,
    public configuracionService: ConfiguracionService,
    public tamanoAppService: TamanoAppService,
    public autenticacionService: AutenticacionService) {}

  ngOnInit() {
    this.IniciarFormulario();
    this.ConsultarRegistros();
  }
  ngAfterViewInit() {
    this.utilitariosService.EstablecerTextoPaginado(this.paginator);
  }

  IniciarFormulario() {
    this.form = this.fb.group({
      filtro: ['']
    });
  }
  ConsultarRegistros() {
    this.mostrarCargando = true;
    this.datosServices.Consultar(this.form.value)
              .subscribe((resp: Maestro_Usuarios[]) =>{
                this.mostrarCargando = false;
                this.listaDatos = resp;
                this.datosServices.ListaUsuarios = resp;
                this.recargarLista();
              },
              (error: Error) => {
                this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
                this.mostrarCargando = false;
                this.cd.detectChanges();
              },
              () => this.cd.detectChanges());
  }
  CancelarRegistro() {
    this.menuService.CambiarComponenteActivo('MenuConfiguracionComponent');
  }
  recargarLista() {
    this.dataSource = new MatTableDataSource(this.listaDatos);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }
  aplicarFiltro(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }
  abrirDetalle(itemSeleccionado: Maestro_Usuarios) {
    this.menuService.CambiarComponenteActivo('MaestrosUsuariosEditarComponent', JSON.stringify(itemSeleccionado));
  }
  RegistrarNuevo() {
    this.menuService.CambiarComponenteActivo('MaestrosUsuariosEditarComponent');
  }
  Eliminar(itemSeleccionado: Maestro_Usuarios) {
    this.consultaSeleccionado = itemSeleccionado;
    this._appconfirmacion.MostrarMensajeConfirmacion();
  }
  ConfirmoUsuario(confirmo: boolean) {
    if (confirmo) {
      this.EliminarRegistro();
    }
  }
  EliminarRegistro() {
    this.mostrarCargando = true;
    this.datosServices.Eliminar(this.consultaSeleccionado)
            .subscribe((resp: RespuestaGenerica) =>{
              this.mostrarCargando = false;
              if (resp.procesoExitoso == false) {
                this.utilitariosService.MensajeToast(resp.mensaje);
              } else {
                this.ConsultarRegistros();
              }
            },
            (error: Error) => {
              this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
              this.mostrarCargando = false;
              this.cd.detectChanges();
            },
            () => this.cd.detectChanges());
  }
}
